<script>
  import GlobalAnonRuleEditor from "./GlobalAnonRuleEditor.svelte";

  export let rules = [];
  export let persist = null;
</script>

<GlobalAnonRuleEditor kind="elements" bind:rules {persist} />
